export default {
  // Hero
  tenderHeroTag: "Tender Support Services",
  tenderHeroTitle1: "Expert Tender",
  tenderHeroTitle2: "Support Services",
  tenderHeroDesc: "AIP's procurement specialists help businesses identify, qualify and win government, NGOs, and private institutional tenders across the region; including bidders registration on procurement portals, bid writing, compliance, and end-to-end submission support.",
  tenderCtaListings: "View Regional Tenders",
  tenderCtaRequest: "Request Support",
  tenderStat1: "Tenders Won",
  tenderStat2: "Sectors Covered",
  tenderStat3: "EA Countries",
  tenderStat4: "Response Time",
  tenderServicesTitle: "Our Tender Support Services",
  tenderService1: "Bidders Registration",
  tenderService1Desc: "We register your company on government & private institution procurement portals across EA",
  tenderService2: "Tender Identification",
  tenderService2Desc: "We scan national & regional portals daily to find your best opportunities",
  tenderService3: "Bid Writing",
  tenderService3Desc: "Professional technical and financial bid preparation by sector specialists",
  tenderService4: "Compliance Review",
  tenderService4Desc: "Full regulatory and eligibility checks before submission",
  tenderService5: "Financial Proposals",
  tenderService5Desc: "Competitive pricing strategy with bid bond & security sourcing",
  tenderService6: "Bid Bond & Security Support",
  tenderService6Desc: "We help businesses acquire bid bonds and securities required for tender participation across procurement portals",
  tenderService7: "Performance Bond",
  tenderService7Desc: "We facilitate the acquisition of performance bonds and guarantees to secure your winning contract after tender award",
  tenderTrustBadge: "AIP is a registered procurement support firm in Rwanda with active partnerships across East African procurement agencies.",

  // List
  listTag: "Regional Tenders",
  listTitle1: "Regional Tender",
  listTitle2: "Listings",
  listDesc: "Active government and institutional tenders across East Africa. Filter by country or sector, then click any tender to view details and request support.",
  listFilterSector: "All Sectors",
  listFilterCountry: "All Countries",
  listClear: "Clear",
  listCount_one: "tender found",
  listCount_other: "tenders found",
  listNoResults: "No tenders match your filters",
  listNoResultsHint: "Try adjusting your selection",
  listColTitle: "Title",
  listColSector: "Sector",
  listColCountry: "Country",
  listColDeadline: "Deadline",
  listColStatus: "Status",
  listView: "View",
  listToday: "Today",
  listLeft: "left",

  // Modal
  modalNeedHelp: "Need help preparing a winning bid for this tender?",
  modalRequestSupport: "Request Tender Support",
  modalSubmitInterest: "Submit Tender Interest",

  // Support Form
  supportTag: "Get Support",
  supportTitle1: "Our Tender",
  supportTitle2: "Support Services",
  supportDesc: "Our tender specialists handle everything from opportunity identification to final submission — including registering your company on government and private procurement portals across East Africa.",
  supportService1: "Bidders Registration",
  supportService1Desc: "We register your company on government and private institution procurement portals across East Africa so you never miss an opportunity.",
  supportService2: "Tender Identification",
  supportService2Desc: "We monitor procurement portals across East Africa and alert you to relevant opportunities.",
  supportService3: "Bid Writing & Strategy",
  supportService3Desc: "Professional technical and financial proposal writing tailored to evaluators' criteria.",
  supportService4: "Compliance Review",
  supportService4Desc: "Full document checklist review to ensure your submission meets all requirements.",
  supportService5: "End-to-End Support",
  supportService5Desc: "From first reading the notice to submission day — we're with you every step.",
  supportService6: "Bid Bond & Security Support",
  supportService6Desc: "We help you acquire bid bonds, tender guarantees, and securities required to qualify and participate in procurement opportunities.",
  supportService7: "Performance Bond",
  supportService7Desc: "We facilitate performance bond acquisition and contract guarantees to secure your obligation after winning a tender award.",
  supportFormTitle: "Request Tender Support",
  supportFormSubtitle: "Complete the form and our team will contact you within 24 hours.",
  supportFormSuccessTitle: "Request Received!",
  supportFormSuccessBody: "Our tender specialists will reach out within 24 hours.",
  supportFormCompany: "Company Name",
  supportFormContact: "Contact Name",
  supportFormEmail: "Email",
  supportFormPhone: "Phone",
  supportFormCountry: "Country",
  supportFormRef: "Tender Reference / Title",
  supportFormType: "Type of Support Needed",
  supportFormInfo: "Additional Information",
  supportFormSubmit: "Request Tender Support",
  supportFormSubmitInterest: "Submit Tender Interest",
  supportFormSelectSupport: "Select support type",
  supportTypeRegistration: "Bidders Registration on Procurement Portals",
  supportTypeIdentification: "Tender Identification",
  supportTypeBidWriting: "Bid Writing",
  supportTypeCompliance: "Compliance Review",
  supportTypeFinancial: "Financial Proposal",
  supportTypeFull: "Full Submission Management",
  supportTypeBidBond: "Bid Bond & Security Support",
  supportTypePerformanceBond: "Performance Bond",
  supportTypeOther: "Other",
  supportFormSelectCountry: "Select country",
  searchTenderPlaceholder: "Search tender title or reference...",
};